import { useMutation, useQuery } from "@tanstack/react-query";
import newApi from "src/newApi";
import { queryClient } from "src/queryClient";

import options from "./defaultOptions";

export interface Cooperation {
	id: number;
	name: string;
	text: string;
	link: string;
	button_text: string;
	image_url?: string;
}

export function useCooperations() {
	return useQuery<Cooperation[]>({
		queryKey: ["cooperations"],
		queryFn: () => newApi.getCooperations(),
		...options,
		staleTime: 60 * 1000,
		gcTime: 60 * 1000,
	});
}

export function useCloseCooperations() {
	return useMutation<unknown, unknown, { id: number }>({
		mutationFn: ({ id }) => newApi.closeCooperation(id),
		onSuccess: () => {
			queryClient.removeQueries({ queryKey: ["cooperations"] });
		},
	});
}
